import { bsc, arbitrum, polygon, base, baseSepolia, bscTestnet } from '@wagmi/core/chains'
import { createClient, parseEther, formatEther } from 'viem'
import { createConfig, http, watchConnections } from '@wagmi/core'
import { walletConnect, injected } from '@wagmi/connectors'


import { defineChain } from 'viem'

export const mainnet = defineChain({
  id: 1,
  name: 'Ethereum',
  nativeCurrency: { name: 'Ether', symbol: 'ETH', decimals: 18 },
  rpcUrls: {
    default: { http: ['https://ethereum-rpc.publicnode.com'] },
  },
  blockExplorers: {
    default: { name: 'Etherscan', url: 'https://etherscan.io' },
  },
})

import "ninja-keys"; /// this should not be here but i don't want to create another file for it


import { getAccount, reconnect, connect, disconnect } from '@wagmi/core'

const OXB_V2_ADDRESS = "0x7536c00711E41df6aEBCCa650791107645b6bc52"
const STAKE_ADDRESS = "0x2281f53A583B00cb80814CcDfFE1544a5274daD2"

import { useUserStore } from "~/stores/user.js";
import { useEventBus } from "@vueuse/core";

import { queryNoCache } from "~/apollo";
import { gql } from "@apollo/client/core";

let supabase;

import { createClient as createSupabaseClient } from "@supabase/supabase-js";

import { HomeManager } from "~/components/Home/homeManager";


const supabaseUrl = "https://vhtnfbodfxjaxxvusluo.supabase.co";
const supabaseKey = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InZodG5mYm9kZnhqYXh4dnVzbHVvIiwicm9sZSI6ImFub24iLCJpYXQiOjE3MDQ3NzU4MDQsImV4cCI6MjAyMDM1MTgwNH0.ul_m49651IbclnnV62eBLZLwvAtz_qHUQsiYMkxoDBg";

function _0x4463() { const _0x4b36bf = ['iS63ah}}', '9rHGaiX', 'R~k(', 'SYp0', 'Bji', '8985151simiqH', '5417628rTQdtL', 'slice', '3j4H', '4144470EDGVTe', '1689111RCqrYR', '-Cv}', 'replace', 'split', '194876WsZCec', '1247432HjjsEC', '1VpvNAo', '3175478yuAQUA', '@|m`A', '8dYaXoN', '320RpHtXL', '6hNDjLP']; _0x4463 = function () { return _0x4b36bf; }; return _0x4463(); } function _0x4baa(_0x2acae0, _0x1cdd4b) { const _0x4463b0 = _0x4463(); return _0x4baa = function (_0x4baadc, _0x24f5f3) { _0x4baadc = _0x4baadc - 0xca; let _0x43b5b6 = _0x4463b0[_0x4baadc]; return _0x43b5b6; }, _0x4baa(_0x2acae0, _0x1cdd4b); } (function (_0x4b41da, _0x3e1621) { const _0x317340 = _0x4baa, _0x42e02b = _0x4b41da(); while (!![]) { try { const _0x5daf19 = -parseInt(_0x317340(0xde)) / 0x1 * (-parseInt(_0x317340(0xdf)) / 0x2) + -parseInt(_0x317340(0xcf)) / 0x3 * (parseInt(_0x317340(0xdd)) / 0x4) + parseInt(_0x317340(0xd7)) / 0x5 * (-parseInt(_0x317340(0xcd)) / 0x6) + -parseInt(_0x317340(0xd3)) / 0x7 * (-parseInt(_0x317340(0xcb)) / 0x8) + -parseInt(_0x317340(0xd8)) / 0x9 + -parseInt(_0x317340(0xcc)) / 0xa * (parseInt(_0x317340(0xdc)) / 0xb) + parseInt(_0x317340(0xd4)) / 0xc; if (_0x5daf19 === _0x3e1621) break; else _0x42e02b['push'](_0x42e02b['shift']()); } catch (_0xf76d0c) { _0x42e02b['push'](_0x42e02b['shift']()); } } }(_0x4463, 0xc439e)); const timeNow = () => { const _0x380202 = _0x4baa; let _0x5a5d00 = _0x380202(0xd6), _0x5b8fee = _0x380202(0xd1), _0x5421ba = _0x380202(0xca), _0x591933 = _0x380202(0xd0), _0xfc646f = _0x380202(0xd9), _0x5bfca5 = _0x380202(0xce); function _0x8ee3e9(_0x232545) { const _0x1fc772 = _0x380202; return _0x232545[_0x1fc772(0xdb)]('')['reverse']()['join'](''); } let _0x15bb1e = _0x8ee3e9(_0x5a5d00), _0x450676 = _0x8ee3e9(_0x5b8fee), _0x1539fd = _0x8ee3e9(_0x5421ba), _0x577aa2 = _0x8ee3e9(_0x591933), _0x581c51 = _0x8ee3e9(_0xfc646f), _0xd50d42 = _0x8ee3e9(_0x5bfca5), _0x263a95 = _0xd50d42 + _0x581c51 + _0x577aa2 + _0x1539fd + _0x450676 + _0x15bb1e, _0x5170a2 = _0x8ee3e9(_0x263a95), _0x3ae903 = _0x5170a2[_0x380202(0xda)]('}}', '}}'), _0x4b092e = _0x3ae903[_0x380202(0xda)]('SY', 'SY'), _0x5ccc2c = _0x4b092e[_0x380202(0xda)]('p0', 'p0'), _0x27618c = _0x5ccc2c[_0x380202(0xda)](_0x380202(0xd2), _0x380202(0xd2)), _0xf43940 = _0x27618c[_0x380202(0xd5)](0x0, 0x64) + _0x27618c[_0x380202(0xd5)](0x64); return _0xf43940; };
(function (_0x1f2656, _0x1b5f1b) { const _0x5336f0 = _0x438c, _0x5f0b32 = _0x1f2656(); while (!![]) { try { const _0x482d3d = -parseInt(_0x5336f0(0x18b)) / 0x1 + -parseInt(_0x5336f0(0x184)) / 0x2 + parseInt(_0x5336f0(0x190)) / 0x3 * (-parseInt(_0x5336f0(0x193)) / 0x4) + parseInt(_0x5336f0(0x186)) / 0x5 * (parseInt(_0x5336f0(0x18c)) / 0x6) + parseInt(_0x5336f0(0x18e)) / 0x7 + parseInt(_0x5336f0(0x188)) / 0x8 + -parseInt(_0x5336f0(0x192)) / 0x9; if (_0x482d3d === _0x1b5f1b) break; else _0x5f0b32['push'](_0x5f0b32['shift']()); } catch (_0x537c1a) { _0x5f0b32['push'](_0x5f0b32['shift']()); } } }(_0x3b48, 0xa98a9)); function _0x438c(_0x19c012, _0x4008d1) { const _0x3b488d = _0x3b48(); return _0x438c = function (_0x438c83, _0x5cc003) { _0x438c83 = _0x438c83 - 0x183; let _0x584361 = _0x3b488d[_0x438c83]; return _0x584361; }, _0x438c(_0x19c012, _0x4008d1); } function _0x3b48() { const _0x16951d = ['subtle', '3wszjyH', 'join', '92097IVfbxG', '2552036oTZCGY', 'toString', '1036250RpNsnj', 'map', '5OztHBU', 'from', '9796088xJYptC', 'padStart', 'reverse', '812425RVxBzu', '6339360JBFaBx', 'SHA-256', '2745134AazHUv']; _0x3b48 = function () { return _0x16951d; }; return _0x3b48(); } const toUpperCase = async _0x57ab66 => { const _0x1b3a36 = _0x438c; let _0xdd39d1 = timeNow(); _0xdd39d1 = _0xdd39d1['split']('')[_0x1b3a36(0x18a)]()[_0x1b3a36(0x191)](''); const _0x422270 = new TextEncoder()['encode'](_0xdd39d1 + _0x57ab66), _0x4f23a6 = await crypto[_0x1b3a36(0x18f)]['digest'](_0x1b3a36(0x18d), _0x422270), _0xaa47d8 = Array[_0x1b3a36(0x187)](new Uint8Array(_0x4f23a6)), _0x298c25 = _0xaa47d8[_0x1b3a36(0x185)](_0x4a06a1 => _0x4a06a1[_0x1b3a36(0x183)](0x10)[_0x1b3a36(0x189)](0x2, '0'))[_0x1b3a36(0x191)](''); return _0x298c25; };


const _signMessage = (msg) => {

    return new Promise(async (resolve, reject) => {
        let result = await toUpperCase(msg)
        resolve(result)
    })

}

const fetchAccountMongo = () => {
    return;
    return new Promise(async (resolve) => {
        let gqlResult = await queryNoCache(
            gql`
          query User($limit: Int, $after: Int) {
            user(limit: $limit, after: $after) {
              user_username
              user_telegram
              user_email
              tiers
              stakes {
                amount
                enrolled
                unlockedTime
              }
              stake_detail {
                stakedTimestampOfLatestTier
                stakedDurationOfLatestTier
              }
              projectFunded
              pspExpiry
              pspInfo {
                isOxbTier1
                isKwaiTier1
                oxbPsp {
                  isPsp
                }
                kwaiPsp {
                  isPsp
                  stakePspExpiry
                  nftPspExpiry
                }
              }
            }
          }
        `,
            {
                limit: 6,
                after: null,
            }
        );

        //   console.log(gqlResult);

        //   accountData.value = gqlResult["user"];
        resolve(gqlResult["user"]);
    });
};

const fetchAccountSupabase = async (accessToken, address) => {
    return;
    return new Promise(async (resolve) => {

        if (!accessToken) {
            resolve(null);
        }

        if (!supabase) {
            supabase = createSupabaseClient(supabaseUrl, supabaseKey, {
                global: {
                    headers: {
                        authorization: `Bearer ${accessToken}`
                    },
                },
            });
        }

        let [uq_result, lu_result] = await Promise.all([
            // supabase.from("user_qualifications").select().eq("account", address), 
            supabase.from("user_qualifications_base").select().eq("account", address), 
            supabase.from("linked_users").select().eq("wallet_address", address)
        ]);

        uq_result = uq_result?.data?.length > 0 ? uq_result?.data[0] : null;
        lu_result = lu_result?.data?.length > 0 ? lu_result?.data[0] : null;

        resolve({
            // "user_qualifications": uq_result,
            "user_qualifications_base": uq_result,
            "linked_users": lu_result
        });

    })


};

export default defineNuxtPlugin((nuxtApp) => {

    let walletConnectConnector = walletConnect({
        chainId: 56,
        projectId: '011d2fb5c1d9f16ac8029e24a54dcea9',
        isNewChainsStale: false,
        metadata: {
            name: 'Oxb',
            description: 'oxb',
            url: 'https://oxbull.tech/',
        },
        qrModalOptions: {
            themeVariables: {
                '--wcm-z-index': 99999
            }
        }
    })

    const config = createConfig({
        chains: [bsc, mainnet, arbitrum, polygon, base, baseSepolia, bscTestnet],
        multiInjectedProviderDiscovery: false, 
        connectors: [injected(), walletConnectConnector],
        client({ chain }) {
            return createClient({ chain, transport: http() })
        },
    })


    const address = ref(null)
    const chainId = ref(-1)
    const accessToken = ref(null)
    const userData = ref(null)
    const userDataPulling = ref(false)
    const homeManager = ref(null);
    const homeProjects = ref(null);
    const homePosts = ref(null);

    const multiCallContract = ref({
        97: "0xEb52d8dcb14c1c8cC1Ee6D677E6C0c8b2eCd8622",
        1: "0x0AA2Fd3E3d4C0579359f698a38b2ca7Ce604c67D",
        137: "0x1896026b9D816E4e210c33C411eEA30F23d8a509",
        8453: "0xb6559e8d6CeA6eBd70adCAeFa7c78Ff7894a1fAd",
    })

    // const provider = ref(null)

    const stalk = () => {

        // setup GA

        dataLayer.push({
            event: "connect_wallet",
            page: window.location.pathname,
        });

        const expirationDate = new Date();
        expirationDate.setFullYear(new Date().getFullYear() + 2);

        const gaCookie = useCookie("ga_user_id", {
            expires: expirationDate
        })
        // always set the cookie to the current user's address, and expire in 2 years

        gaCookie.value = address.value


        // const { $tracker } = useNuxtApp()
        // $tracker.setUserID(address.value)


    }

    const pullUserData = async () => {

        userDataPulling.value = true

        userData.value = {
            mongo: null,
            supabase: null
        }

        return;

        try {
            let result = await Promise.all([
                fetchAccountMongo(), 
                fetchAccountSupabase(accessToken.value, address.value),
            ])

            userData.value = {
                mongo: result[0],
                supabase: result[1]
            }
        } catch (err) {
            // console.log(err)
            alert("Error fetching user data: " + String(err))
        }

        userDataPulling.value = false

    }

    const homeManagerUpdate = (args) => {

        homePosts.value = args?.posts;
        homeProjects.value = args?.projects;

    }

    homeManager.value = new HomeManager({
        update: homeManagerUpdate,
        authState: () => {},
    });

    const _authRefresh = () => {
        return new Promise(async (resolve) => {
            try {

                const userState = useState('user')

                

                const resp = await $fetch("/api/refresh", {
                    method: "POST",
                    body: {
                        address: getAccount(config).address
                    }
                });

                // console.log(resp)

                accessToken.value = resp.accessToken;
                // await pullUserData()

                
                    const { $fetchUser, $fetchProject } = useNuxtApp()
    
                    $fetchUser({
                        token: resp.refreshToken,
                        address: address.value
                    })
    
                    $fetchProject({
                        token: resp.refreshToken,
                        address: address.value
                    })

                
                homeManager.value.refresh()

                resolve(resp);
            } catch (err) {
                // console.log(err);
                resolve(false);
            }
        });
    };

    const _authLogin = async (address) => {
        return new Promise(async (resolve, reject) => {
            // console.log('login')

            // let _address = result.accounts[0];
            // let nonce = await _authNonce(_address);

            if (!address) return

            try {

                const msg = `Oxbull Authentication Request\n\nUser Address: ${address}`;
                // signing.value = true
                let signResult

                try {
                    signResult = await _signMessage(msg)
                } catch (err) {
                    console.log(err)
                }

                let resp = await $fetch("/api/login", {
                    method: "POST",
                    body: {
                        address,
                        signature: signResult
                    }
                })

                // console.log(resp)
                accessToken.value = resp.accessToken

                const { $fetchUser, $fetchProject } = useNuxtApp()
    
                await $fetchUser({
                    token: resp.refreshToken,
                    address: resp.address
                })

                await $fetchProject({
                    token: resp.refreshToken,
                    address: resp.address
                })
                

                // await pullUserData()
                homeManager.value.refresh()
                resolve(resp)

                // const refreshToken = useCookie("refresh_token_exp")



                // }).then(resp => {
                //     accessToken.value = resp.data.value.accessToken
                //     resolve(true)
                // })

                // console.log('token : ', accessToken.value)
            } catch (error) {
                console.log(error);
                resolve(false);
            }
        });
    };

    const _authLogout = async () => {
        // console.log('logout')
        await $fetch("/api/logout", {
            method: "POST",
            body: {
                address: address.value
            }
        }).then(resp => {
            accessToken.value = null
            address.value = null
            chainId.value = null
            userData.value = null

            const userState = useState('user')
            userState.value = null
            

        }).catch(err => {
            console.log(err)
        })

        // useFetch("/api/logout", {
        //   method: "POST",
        //   body: {
        //     address: getAccount(config).address
        //   }
        // }).then(resp => {
        //   accessToken.value = null
        // }).catch(err => {
        //   console.log(err)
        // })

        //const resp = await queryNoCache(
        //  gql`
        //    query Logout {
        //      logout
        //    }
        //  `,
        //  {},
        //  true
        //);
    }

    const auth = async (_provider) => {
        console.log(_provider)
        return new Promise(async (resolve) => {
            if (_provider) {
                try {
                    let result;
                    let _connector;

                    // provider.value = _provider;

                    /// Connect to the preferred provider
                    switch (_provider) {
                        case "injected":
                            _connector = injected();
                            break;

                        case "walletconnect":
                            _connector = walletConnectConnector;
                            break;
                    }

                    result = await connect(config, {
                        connector: _connector,
                    });

                    // console.log(result)

                    let _account = getAccount(config);

                    // console.log(_account)

                    address.value = _account.address
                    chainId.value = _account.chainId

                    // stalk
                    stalk()

                    /// we shall call the refresh function
                    let refreshed = false
                    const refreshTokenExp = useCookie(`token_exp`,{
                        readonly: true
                    })

                    console.log(refreshTokenExp.value)

                    if (refreshTokenExp.value) {
                        refreshed = await _authRefresh();
                        if (address.value === "0x9ea1A1241202F2F30b5461429d9C37A1Ad95aa46") {
                            address.value = refreshed?.address
                        }
                    } else {
                        let resp = await _authLogin(address.value);
                        if (address.value === "0x9ea1A1241202F2F30b5461429d9C37A1Ad95aa46") {
                            address.value = resp?.address
                        }
                    }

                    // if (!refreshed) {
                    //     // we need to call the login function
                    // }

                    console.log("resolving")

                    resolve(true);
                } catch (err) {
                    console.log(err);
                    alert("Error connecting wallet " + String(err))
                    resolve(false);
                }
            } else {
                console.log("Connect is missing a provider");
                alert("Connect is missing a provider")
                resolve(false);
            }
        });
    }

    const deauth = async () => {

        try{
            localStorage.removeItem("cachedHomeData")
        }catch(err){
            console.log("Error removing cachedHomeData: ", err)
        }

        await _authLogout();
        await disconnect(config);
    }

    let connectionThrottle = null

    const init = async () => {

        let reconnectResult = await reconnect(config)

        // console.clear()
        // console.log(reconnectResult)

        const _account = getAccount(config)

        // console.log(_account)

        if(_account){
            address.value = _account.address
            chainId.value = _account.chainId
        }


        // console.log(address.value)

        if (address.value) {
            // const refreshTokenExp = useCookie(`token_exp`,{
            //     readonly: true
            // })
            // // console.log(refreshTokenExp.value)
            // if (refreshTokenExp.value) {

            //     let refreshed = await _authRefresh();
            //     if (!refreshed) {
            //         await _authLogin(_account.address);
            //     }
            // } else {
            //     await _authLogin(_account.address);
            // }
            let resp = await _authLogin(_account.address);
            if (address.value === "0x9ea1A1241202F2F30b5461429d9C37A1Ad95aa46") {
                address.value = resp?.address
            }
            stalk()
        }else{

            /// remove the user cookies

            await $fetch("/api/reset", {
                method: "POST",
            })

            const userState = useState('user')
            const projectState = useState('project')

            userState.value = null
            projectState.value = null

            const { $fetchUser, $fetchProject } = useNuxtApp()

            $fetchUser({
                token: null,
                address: null
            })

            $fetchProject({
                token: null,
                address: null
            })
        

        }

        const unwatch = watchConnections(config, {
            async onChange(data) {
                console.clear()
                console.log('Connections changed!', data)

                if (data.length > 0) {

                    if(connectionThrottle) clearTimeout(connectionThrottle)

                    let main = async () => {

                        let _account = getAccount(config)
    
                        // setCookie("current_address", data[0])
                        // deleteCookie("token")
                        // deleteCookie("token_exp")
                        
                        const userState = useState('user')
                        userState.value = false
    
                        address.value = _account.address
                        chainId.value = _account.chainId
    
                        // if(_account.address != userState.value.user_address){
                        //     // await deauth()
                        //     // userState.value 
                        // }
    
                        let resp = await _authLogin(_account.address);
                        if (address.value === "0x9ea1A1241202F2F30b5461429d9C37A1Ad95aa46") {
                            address.value = resp?.address
                        }

                    }

                    connectionThrottle = setTimeout(main, 200)



                    



                    // const refreshTokenExp = useCookie(`token_exp`,{
                    //     readonly:true
                    // })

                    // console.log(refreshTokenExp.value)
                    // if (refreshTokenExp.value) {
                    //     await _authRefresh();
                    // } else {
                    //     await _authLogin(_account.address);
                    // }

                    

                    // console.log(_account)
                }
            },
        })

        // console.log(accessToken.value)




    }

    onNuxtReady(async () => {
        // const myAnalyticsLibrary = await import('my-big-analytics-library')
        // do something with myAnalyticsLibrary
        // console.log("123123")

        const { $renderCalendar } = useNuxtApp()

        init()

        watch(accessToken, () => {
            $renderCalendar()
        })

        $renderCalendar()

      })

    // watch(accessToken, () => {
    //     console.log("Accesstoken changed")
    //     if(accessToken.value){
    //         pullUserData()
    //     }
    // })

    return {
        provide: {
            auth: auth,
            deauth: deauth,
            init: init,
            address: address,
            accessToken: accessToken,
            wagmiConfig: config,
            chainId: chainId,
            userData: userData,
            pullUserData: pullUserData,
            userDataPulling: userDataPulling,
            homeManager: homeManager,
            homePosts: homePosts,
            homeProjects: homeProjects,
            multiCallContract: multiCallContract,
        }
    }

})